const axios = require("axios");

module.exports = class Logger {
  static logs = [];
  static logIntervalIdentifier = null;
  static sendLogsFrequency = 2000;
  static maxChunkSize = 100;
  static timeout = 5000;

  static getApiBaseUrl() {
    return process.env.API_LOG_URL;
  }
  static getSessionId() {
    return localStorage.getItem('SESSION_ID');
  }

  static log(message, data = {}) {
    this.addMessage(this.buildLogMessage(message, data, 'INFO'));
  }
  static warn(message, data = {}) {
    this.addMessage(this.buildLogMessage(message, data, 'WARN'));
  }
  static error(message, data = {}) {
    this.addMessage(this.buildLogMessage(message, data, 'ERROR'));
  }

  static buildLogMessage(message, data, logLevel = '') {
    return this.getSessionId() + ' '+ logLevel + ' ' + JSON.stringify({message, data});
  }

  static addMessage(message) {
    const now = Date.now();
    this.logs.push({Message: message, Timestamp: now});

    if (this.logIntervalIdentifier === null) {
      this.logIntervalIdentifier = setInterval(this.sendLogs.bind(this), this.sendLogsFrequency);
    }
  }

  static getApiPayload(logsChunk) {
    return {
      logGroupName: process.env.LOG_GROUP_NAME,
      logInterval: process.env.LOG_GROUP_NAME + '/' + Math.floor(Date.now() / 1000 / 60 / 20), // 20 minutes log interval
      messages: logsChunk
    };
  }

  static getApiOptions() {
    return {
      timeout: this.timeout,
      headers: {}
    }
  }

  static sendLogs() {
    if (this.logs.length === 0) {
      return;
    }
    let logsChunk;

    if (this.logs.length > this.maxChunkSize) {
      logsChunk = this.logs.slice(0, this.maxChunkSize);
    } else {
      logsChunk = this.logs;
    }

    try {
      axios.post(
        `${this.getApiBaseUrl()}/log`,
        this.getApiPayload(logsChunk),
        this.getApiOptions()
      );
    } catch (e) {
      console.error(e);
    }

    this.logs = this.logs.slice(logsChunk.length);
  }
}